import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=47d1f5c1&scoped=true&"
import script from "./productDetail.vue?vue&type=script&lang=js&"
export * from "./productDetail.vue?vue&type=script&lang=js&"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=47d1f5c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d1f5c1",
  null
  
)

export default component.exports